/**
 * Chat Slices Module
 *
 * Re-exports all chat slices and combines them
 */
import { combineReducers } from '@reduxjs/toolkit';

// Import reducers
import { messagesReducer, type MessagesState } from './messagesSlice';
import { templateReducer, type TemplateState } from './templateSlice';
import { chatListReducer, type ChatListState } from './chatListSlice';

// Re-export actions from messages slice
export {
  addUserMessage,
  updateStreamingMessage,
  appendPollResultMessage,
  completeStreaming,
  abortStreaming,
  addThinkingMessage,
  clearThinkingMessages,
  setStreamingError,
  setLoading,
  setMessages,
  prependMessages,
  setLoadingMore,
  clearMessages,
  resetMessagesState,
  setSkipHistoryLoad,
  setPendingQuery,
  clearPendingQuery,
} from './messagesSlice';

// Re-export actions from template slice
export {
  setPendingTemplate,
  clearPendingTemplate,
  setActiveTemplate,
  updateTemplateFromStream,
  clearActiveTemplate,
  resetTemplateState,
} from './templateSlice';

// Re-export actions from chat list slice
export {
  setChatListLoading,
  setChatListLoadingMore,
  setChatList,
  appendChatList,
  setChatListError,
  resetChatList,
} from './chatListSlice';

// Re-export types
export type { MessagesState } from './messagesSlice';
export type { TemplateState } from './templateSlice';
export type { ChatListState } from './chatListSlice';

// Combined state type
export interface ChatState {
  readonly messages: MessagesState;
  readonly template: TemplateState;
  readonly chatList: ChatListState;
}

// Combined reducer
export const chatReducer = combineReducers({
  messages: messagesReducer,
  template: templateReducer,
  chatList: chatListReducer,
});
